export const ACTION_TYPES = {
	SET_CUSTOMERS: 'SET_CUSTOMERS',
	REMOVE_CUSTOMERS: 'REMOVE_CUSTOMERS',
}